import Network from '@/services/network'
import {ref} from 'vue'

export default function handleBarcode() {
    const network = new Network;
    const loading = ref(false)

    const fetchBarcode = (query) => {
        return network.api('get', '/get/barcode' + query);
    }

    const fetchBarcodeTwo = (query) => {
        return network.api('get', '/public/get/barcode' + query);
    }

    const fetchBarcodeBatch = (data) => {
        return network.api('post', '/get/barcode-batch', data);
    }

    return {
        fetchBarcode,
        fetchBarcodeTwo,
        fetchBarcodeBatch,
        loading
    }
}
